; "use strict";

import State from './state';
import drugData from './drugdata';
import rpszData from './rpsz-meth';
import stData from './rpsz-st';

class RpszModel {

	constructor() {

		let group;

		for(group in rpszData) State.rpszPatsBuf[group] = -1;
	}

/////////////////////////////

	calcOneGroup(st, chan) {

		let cnt, len, drugSet, doseSet, nOfDrugs, currDrugN, nOfPatients, mgTotal,
			cycleDose, currDrug, drugIndex, nOfCycles, currPrice, cyclesRound, 
			drugDose, drugBudget, methodBudget, groupBudget, drugPack, nOfPacks;

//!!TODO Возможно просто вызвать calcOneGroup из модуля Calc

		const methSet = rpszData[st].meth;
//console.log(st);
//if(st!='st0_2_6') return 0;
//console.log('------------>');
		groupBudget = 0;
		len = methSet.length;
		for(cnt=0 ; cnt<len ; cnt++) {
			drugSet = methSet[cnt].drugs;
			doseSet = methSet[cnt].dose;
			nOfDrugs = drugSet.length;
			nOfCycles = methSet[cnt].cycles; // N of infusions for year 
										// for current method of therapy
if(chan=='oms') nOfPatients = methSet[cnt].oms;
else if(chan=='omsd') nOfPatients = methSet[cnt].omsd;
else if(chan=='rlo') nOfPatients = methSet[cnt].rlo;
else if(chan=='onls') nOfPatients = methSet[cnt].onls;
else nOfPatients = methSet[cnt].pats;
//!!TODO Временная заглушка для маленьких групп распределения, когда
//		nOfPatients некорректно расчитывается
				if(isNaN(nOfPatients)) continue; 
			methodBudget = 0;							
//console.log(State.drugBuf);
			for(currDrugN=0 ; currDrugN<nOfDrugs ; currDrugN++) {
				drugIndex = drugSet[currDrugN];
				cycleDose = doseSet[currDrugN];
// console.log(drugIndex);
// if(drugIndex==2) console.log(drugData);
				currDrug = drugData[drugIndex];

				currPrice = currDrug.price; // Price of one pack
				drugDose = currDrug.dose;	// Dose of one tablet or flask
				drugPack = currDrug.set;		// N of items in pack

// Вариант округляющий упаковки до курса для таблеток и до цикла для флаконов
if(currDrug.tab) { // Таблетированная форма
	nOfPacks = Math.ceil(cycleDose/drugDose); // Таблеток на цикл
	nOfPacks = Math.ceil(nOfPacks*nOfCycles[currDrugN]/drugPack); // Пачек на курс
	nOfPacks = nOfPacks*nOfPatients // Пачек на курс на всех
}
else {
	nOfPacks = Math.ceil(cycleDose/drugDose/drugPack); // Упаковок на цикл
	nOfPacks = nOfPatients*Math.ceil(nOfPacks*nOfCycles[currDrugN]);
}
	mgTotal = Math.round(nOfPacks*drugDose*drugPack); 

				nOfPacks = Math.ceil(nOfPacks);
				drugBudget = nOfPacks*currPrice;
				State.drugBuf[drugIndex].summ += drugBudget;
				State.drugBuf[drugIndex].packs += nOfPacks;
				State.drugBuf[drugIndex].mg += mgTotal;
				methodBudget += drugBudget;
				if(chan=='oms') {		
					State.omsBuf[drugIndex].summ += drugBudget;
					State.omsBuf[drugIndex].packs += nOfPacks;
					State.omsBuf[drugIndex].mg += mgTotal;
					State.chanBudgets[chan] += drugBudget;
				}
				if(chan=='omsd') {		
					State.omsdBuf[drugIndex].summ += drugBudget;
					State.omsdBuf[drugIndex].packs += nOfPacks;
					State.omsdBuf[drugIndex].mg += mgTotal;
					State.chanBudgets[chan] += drugBudget;
				}
				if(chan=='rlo') {
					State.rloBuf[drugIndex].summ += drugBudget;
					State.rloBuf[drugIndex].packs += nOfPacks;
					State.rloBuf[drugIndex].mg += mgTotal;
					State.chanBudgets[chan] += drugBudget;
				}
				if(chan=='onls') {
					State.onlsBuf[drugIndex].summ += drugBudget;
					State.onlsBuf[drugIndex].packs += nOfPacks;
					State.onlsBuf[drugIndex].mg += mgTotal;
					State.chanBudgets[chan] += drugBudget;
				}	
			}
			groupBudget += methodBudget;	
			if(chan=='oms') {		
				State.stIncome += nOfPatients*
				State.distPanel.calcMethodIncome(methSet[cnt].st, methSet[cnt].cycles[0]); 	
				cyclesRound = Math.ceil(methSet[cnt].cycles[0]);
				State.nOfCasesKs += nOfPatients*cyclesRound;
				if(methSet[cnt].st && methSet[cnt].st!='') {
					State.ksgBuf[methSet[cnt].st] += nOfPatients*cyclesRound;
				}
			}
			if(chan=='omsd') {		
				State.dsIncome += nOfPatients*
				State.distPanel.calcMethodIncome(methSet[cnt].ds, methSet[cnt].cycles[0]); 	
				cyclesRound = Math.ceil(methSet[cnt].cycles[0]);
				State.nOfCasesDs += nOfPatients*cyclesRound;
				if(methSet[cnt].ds && methSet[cnt].ds!='') {
					State.ksgBuf[methSet[cnt].ds] += nOfPatients*cyclesRound;
				}
			}
		}
	return groupBudget;
	}


/////////////////////////////
// Распределяем кол-ва пациентов в группе по методам

	distributeMeth(group) {

		let pathData, prob;

		if(State.flNoDist) return; // Отладочный режим

		pathData = rpszData;
		let methSet = pathData[group]['meth'];
		let len, i, res, total, probBuf=[], patBuf=[];
// Формируем массив вероятностей
		if(pathData[group].result!=-1) total = pathData[group].result;
		else total = pathData[group].pats;
		len = methSet.length;
		for(i=0 ; i<len ; i++) {
			prob = methSet[i].pats/total*100;
			probBuf.push(prob);
			patBuf.push(0);
		}
		State.calc.disributePats(total, probBuf, patBuf);
		for(i=0 ; i<len ; i++) {
			res = patBuf.splice(0,1);
			methSet[i].pats = res[0]; 
		}
	}

/////////////////////////////
// Суммируем для текущией патологии всех пациентов для данной группы
// Необходима в случае, если сумма процентов для всех методов в группе больше 100%

	summGroupPats(group) {

		let totalPatsBuf = State.stPats[13];
		let total = totalPatsBuf[group];
		let methSet = rpszData[group].meth;
		let summ = 0, len, i, pats;

		len = methSet.length;
		for(i=0 ; i<len ; i++) {
			pats = total*methSet[i].rate/100.0;
			summ += pats;
		}
		return summ;
	}

/////////////////////////////
// Распределяем общее число пациентов по методам для всех групп
//

	distributeAllMeth() {

// // Для каждой группы пробегаемся по списку методов и считаем сумму пациентов
// 		let pathData = rpszData;
// 		let currGroup, currSumm,i,customVal;
// 		let pathSumm = 0; // Накопитель для фактической суммы пациентов проходящих
// 							// терапию в течение года 
// 		for(currGroup in pathData) {
//  			currSumm = this.summGroupPats(currGroup);
//  			currSumm = Math.ceil(currSumm);
// // Заносим сумму пациентов в данные группы
//  			if(!State.flNoDist)	pathData[currGroup].pats = currSumm;
// // Для каждой группы перераспределяем пациентов по методам
// 			this.distributeMeth(currGroup);
// 		}
// 		for(currGroup in pathData) {
// 			if(pathData[currGroup].result==-1) pathSumm += pathData[currGroup].pats;
// 			else pathSumm += pathData[currGroup].result;
// 		}
// 		// Сохраняем полное фактическое кол-во пациентов в хранилище
// 		State.pathSumm[7] = pathSumm;

// <================


		let i, currGroup, pats;
		let pathSumm = 0; // Накопитель для фактической суммы пациентов проходящих
							// терапию в течение года 
		for(currGroup in rpszData) {
// Восстанавливаем исходное распределение пациентов, нарушенное при предыдущем
// проходе процедуры
			if(State.rpszPatsBuf[currGroup]!=-1) {
				rpszData[currGroup].pats = State.rpszPatsBuf[currGroup]; 
			}

// Для каждой группы нужно пересчитать общее количество пациентов,
// исходя из того, что сумма процентов по методам больше 100%
// Суммируем пациентов внутри каждой группы

			let currGrData = rpszData[currGroup].meth;
			let rpszGrSumm = 0, len = currGrData.length, num;
			if(rpszData[currGroup].result!=-1 && State.rpszMultBuf[currGroup]) {
				pats = Math.round(rpszData[currGroup].result/State.rpszMultBuf[currGroup]);
			}
			else {
				pats = rpszData[currGroup].pats;
			} 
			for(i=0 ; i<len ; i++) {
				num = currGrData[i].rate*pats/100.0;
				if(!State.flNoDist)	currGrData[i].pats = num; 
				rpszGrSumm += num;
			}
			rpszGrSumm = Math.ceil(rpszGrSumm);
// Перезаписываем новое значение в группу
			rpszData[currGroup].pats = rpszGrSumm;
			pathSumm += rpszGrSumm;
// Для каждой группы перераспределяем пациентов по методам
			this.distributeMeth(currGroup);
// Сохраняем множитель распределения в буфере
			State.rpszMultBuf[currGroup] = rpszGrSumm/pats;
// Сохраняем начальное распределение в буфере
			State.rpszPatsBuf[currGroup] = pats;			
		}

		// Сохраняем полное фактическое кол-во пациентов в хранилище
		State.pathSumm[13] = pathSumm;
	}


/////////////////////////////
// Распределяем общее число пациентов текущего региона по стадиям
// и группам для РП

	distributeSt() {

		let Data = rpszData, currGroup;
		let stPats = [], total = State.pathTotals[13],
			recidPats = [], recidTotal = 0;
		let totalPatsBuf = State.stPats[13];
		let stProbs = [13.5, 45.1, 21.5, 18.9],
				recidProbs = [0, 10, 15, 20];
		stProbs = stData[State.currRegNum];
		let	dead = State.currLeth['rpsz'], i;
			for(i=0 ; i<4 ; i++) {
				stPats[i] = total*stProbs[i]/100.0;
				recidPats[i] = stPats[i]*recidProbs[i]/100.0;
				recidTotal += recidPats[i];
			}

		let nMKrrPz = (recidPats[1] + recidPats[2])*0.16;
		let mKrrPz1 = (recidTotal - nMKrrPz)*0.95;	

// Стадия II
		Data['st2_0_1'].pats = Math.round(stPats[1]*0.25);
		totalPatsBuf['st2_0_1'] = Math.round(stPats[1]*0.25);
// Стадия III
		Data['st3_0_1'].pats = Math.round(stPats[2]*0.56*3);
		totalPatsBuf['st3_0_1'] = Math.round(stPats[2]*0.56*3);

// Стадия IV Гормоночувствительный
		Data['st4_0_1'].pats = Math.round(stPats[3]*0.95*2);
		totalPatsBuf['st4_0_1'] = Math.round(stPats[3]*0.95*2);

// нмКРРПЖ
		Data['st4_0_2'].pats = Math.round(nMKrrPz);
		totalPatsBuf['st4_0_2'] = Math.round(nMKrrPz);

// мКРРПЖ 1-я линия
		Data['st4_1_3'].pats = Math.round(mKrrPz1);
		totalPatsBuf['st4_1_3'] = Math.round(mKrrPz1);

// мКРРПЖ 2-я линия
		Data['st4_2_4'].pats = Math.round(mKrrPz1*0.9);
		totalPatsBuf['st4_2_4'] = Math.round(mKrrPz1*0.9);

// КРРПЖ гормонотерапия
		Data['st0_0_5'].pats = Math.round(nMKrrPz+mKrrPz1*1.9);
		totalPatsBuf['st0_0_5'] = Math.round(nMKrrPz+mKrrPz1*1.9);


		for(currGroup in Data) {
			State.rpszPatsBuf[currGroup] = -1;
			Data[currGroup].result = -1;
		}

		this.distributeAllMeth();
	}
		

}

export default RpszModel;